import {
  IFormCategory,
  IFormCategoryInput,
} from '~/client/graph/types.generated'

import Localization from '../localization/LocalizationManager'

export type IWorkflowCategoryDto = IFormCategory
export type IWorkflowCategoryInput = IFormCategoryInput

export default class WorkflowCategory {
  public static fromDto(dto: IWorkflowCategoryDto): WorkflowCategory {
    return new WorkflowCategory(
      dto.id,
      dto.label,
      dto.internalName,
      dto.projectId,
      dto.isDeleted,
      dto.createdAt,
      dto.updatedAt,
    )
  }

  public static createNew(
    name: string,
    projectId: string,
    internalName?: string,
  ): WorkflowCategory {
    return new WorkflowCategory(null, name, internalName, projectId)
  }

  public constructor(
    public id: string,
    private _label: string,
    private _internalName: string,
    private projectId?: string,
    public isDeleted?: boolean,
    public readonly createdAt?: number,
    public readonly updatedAt?: number,
  ) {}

  public get name(): string {
    return this.isDeleted
      ? `[${Localization.translator.deleted}] ${this._label}`
      : this._label
  }

  public set name(value: string) {
    if (this.projectId) {
      this._label = value
    }
  }

  public get isDefaultCategory(): boolean {
    return !this.projectId
  }

  public get internalName(): string {
    return this._internalName
  }

  public toDto(): IWorkflowCategoryInput {
    return {
      id: this.id,
      label: this._label,
      internalName: this._internalName,
      projectId: this.projectId,
    }
  }
}
